
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workshops",
      function () {
        return require("private-next-pages/workshops/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/workshops"])
      });
    }
  